const state = {
  cognitoInfo: {},
  groups: {},
  loggedIn: false,
  loadingState: true,
  errorLoadingState: false,
  isInGroup(group) {
    if (!this.cognitoInfo.groups) return false;

    return this.cognitoInfo.groups.indexOf(group) >= 0;
  },
  hasAnyGroup(groups) {
    if (!groups) {
      return false;
    }

    groups.forEach(group => {
      if (this.cognitoInfo.groups.indexOf(group) >= 0) return true;
    });

    return false;
  }
};

function setLoggedIn(newValue) {
  state.loggedIn = newValue;
}

function setLoggedOut() {
  state.loggedIn = false;
  state.cognitoInfo = {};
}

function setCognitoInfo(newValue) {
  state.cognitoInfo = newValue;
}

export default {
  state,
  setLoggedIn,
  setLoggedOut,
  setCognitoInfo
};
